import styled from "styled-components";
import variables from "../style/variables";

const {
	font_family_th,
	font_color,
	font_title_color,
	font_title_weight,
	screen_xs_max,
	screen_sm_max,
} = variables;

export const BlogContainer = styled.div`
	display: flex;
	margin-top: 40px;
	font-family: ${font_family_th};
	min-height: 50vh;
	margin-bottom: 60px;

	@media (max-width: ${screen_sm_max}) {
		flex-direction: column;
	}
`;
export const BlogContainerDetail = styled.div`
	display: flex;
	font-family: ${font_family_th};
	min-height: 50vh;
	margin-bottom: 60px;

	@media (max-width: ${screen_sm_max}) {
		flex-direction: column;
	}
`;
export const BlogLayoutMenu = styled.div`
	flex: 3;
	@media (max-width: ${screen_sm_max}) {
		flex: 1;
		.list {
			margin-bottom: 15px;
			.list-item {
				display: inline-block;
			}
		}
	}
`;
export const BlogLayoutContent = styled.div`
	flex: 10;
	@media (max-width: ${screen_sm_max}) {
		flex: 1;
	}
`;

export const Media = styled.div`
	display: flex;
	margin-bottom: 30px;
	color: ${font_color};
	&:hover {
		text-decoration: none;
	}
	@media (max-width: ${screen_xs_max}) {
		flex-direction: column;
	}
`;

export const ImageGroup = styled.div`
	width: 170px;
	@media (max-width: ${screen_sm_max}) {
		width: 220px;
	}
	@media (max-width: ${screen_xs_max}) {
		width: 100%;
	}
`;
export const MediaBody = styled.div`
	flex: 1;
	padding: 0px 20px 0 20px;
	@media (max-width: ${screen_xs_max}) {
		padding: 8px 0;
	}
`;

export const Title = styled.h5`
	color: ${font_title_color};
	font-size: 18px;
	margin-top: 0px;
	margin-bottom: 10px;
	font-weight: bold;
	font-family: ${font_family_th};
`;

export const SubTitleList = styled.ul`
	display: block;
	list-style: none;
	padding-left: 0px;
`;
export const SubTitle = styled.li`
	display: inline-block;
	color: ${font_title_color};
	font-size: 12px;
	font-weight: bold;
	margin: 0;
	font-family: ${font_family_th};
	padding-left: 8px;
	padding-right: 8px;
	&:first-child {
		padding-left: 0px;
	}
	&.date {
		border-left: 1px solid #ddd;
	}
`;

export const Image = styled.img`
	width: 100%;
	height: auto;
`;

export const Content = styled.div`
	width: 100%;
	img,
	video {
		height: auto;
		max-width: 100%;
	}
`;
export const ContentHeader = styled.div`
	display: block;
`;

export const ContentTitle = styled.h2`
	font-family: ${font_family_th};
	font-size: 36px;
	font-weight: ${font_title_weight};
	color: ${font_title_color};
`;

export const MediaTEST = styled.div`
	display: flex;
	flex: 1;
	margin-bottom: 30px;
	color: ${font_color};
	&:hover {
		text-decoration: none;
	}
	@media (max-width: ${screen_xs_max}) {
		flex-direction: column;
	}
`;

export const BlogContainerYT = styled.div`
	margin-top: 40px;
	font-family: ${font_family_th};
	min-height: 50vh;
	margin-bottom: 60px;
`;

export const LoadingSpin = styled.div`
	animation: rotate 1s infinite;
	height: 50px;
	width: 50px;
	margin: 0 auto;

	&:before,
	&:after {
		border-radius: 3px;
		content: "";
		display: block;
		height: 20px;
		width: 20px;
	}

	&:before {
		animation: ball1 1s infinite;
		background-color: #009dc7;
		box-shadow: 30px 0 0 #f7be38;
		margin-bottom: 10px;
	}

	&:after {
		animation: ball2 1s infinite;
		background-color: #3469b2;
		box-shadow: 30px 0 0 #4db698;
	}

	@keyframes rotate {
		0% {
			-webkit-transform: rotate(0deg) scale(0.8);
			-moz-transform: rotate(0deg) scale(0.8);
		}
		50% {
			-webkit-transform: rotate(360deg) scale(1.2);
			-moz-transform: rotate(360deg) scale(1.2);
		}
		100% {
			-webkit-transform: rotate(720deg) scale(0.8);
			-moz-transform: rotate(720deg) scale(0.8);
		}
	}

	@keyframes ball1 {
		0% {
			box-shadow: 30px 0 0 #f7be38;
		}
		50% {
			box-shadow: 0 0 0 #f7be38;
			margin-bottom: 0;
			-webkit-transform: translate(15px, 15px);
			-moz-transform: translate(15px, 15px);
		}
		100% {
			box-shadow: 30px 0 0 #f7be38;
			margin-bottom: 10px;
		}
	}

	@keyframes ball2 {
		0% {
			box-shadow: 30px 0 0 #4db698;
		}
		50% {
			box-shadow: 0 0 0 #4db698;
			margin-top: -20px;
			-webkit-transform: translate(15px, 15px);
			-moz-transform: translate(15px, 15px);
		}
		100% {
			box-shadow: 30px 0 0 #4db698;
			margin-top: 0;
		}
	}
`;

export const DivButtonMore = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}
`;
export const PagesNext = styled.a`
	display: inline-block;
	padding: 6px 12px;
	margin-bottom: 0;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.42857143;
	text-align: center;
	white-space: nowrap;
	vertical-align: middle;
	-ms-touch-action: manipulation;
	touch-action: manipulation;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	background-image: none;
	border: 1px solid transparent;
	border-radius: 4px;
	color: #333;
	background-color: #fff;
	border-color: #ccc;
`;



// WEBPACK FOOTER //
// ./src/components/style/blog.jsx